module.exports = __webpack_public_path__ + "img/122.77572a8f.jpg";